// Stop-motion frame clock. Sprite frames advance strictly at 12fps even though
// the renderer runs at 60Hz — that cadence IS the claymation look (AGENT.md §1).

export const ANIMATION_FPS = 12;
export const ANIMATION_FRAME_MS = 1000 / ANIMATION_FPS;
/** Forgives float residue so an exact second still yields exactly 12 frames. */
const EPSILON_MS = 1e-6;

export class AnimationStepper {
  private accumulatorMs = 0;
  private frame = 0;

  /** Feed real elapsed ms; returns how many 12fps frames were crossed. */
  advance(realDeltaMs: number): number {
    this.accumulatorMs += realDeltaMs;
    let stepped = 0;
    while (this.accumulatorMs >= ANIMATION_FRAME_MS - EPSILON_MS) {
      this.accumulatorMs -= ANIMATION_FRAME_MS;
      this.frame++;
      stepped++;
    }
    // Guard against a huge delta after a backgrounded tab.
    if (stepped > ANIMATION_FPS) this.accumulatorMs = 0;
    return stepped;
  }

  /** Monotonic frame counter since start. */
  getFrame(): number {
    return this.frame;
  }

  /** Current frame index within a looping clip of `frameCount` frames. */
  frameIn(frameCount: number, offset = 0): number {
    if (frameCount <= 0) return 0;
    return (this.frame + offset) % frameCount;
  }

  reset(): void {
    this.accumulatorMs = 0;
    this.frame = 0;
  }
}
